import { render, staticRenderFns } from "./ClaimsLayout.vue?vue&type=template&id=bc5e233e&"
import script from "./ClaimsLayout.vue?vue&type=script&lang=js&"
export * from "./ClaimsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports